import { socket, blId } from "./config.js";

let username = "";
let uid = "";
let color = "";
let avatar = null;

export const setUserInfo = (u, i, c, a) => {
    username = u;
    uid = i;
    color = c;
    avatar = a ?? null;
};

export const getUserInfo = () => ({ username, uid, color, avatar });

export const sendMessageToServer = (message, data) => {
    if (!socket || !socket.connected) return;

    socket.emit(message, {
        blId,
        message,
        data,
        username,
        uid,
        color,
    });
};

export const sendChangeToServer = (data) => {
    if (!socket || !socket.connected) return;

    socket.emit("projectChange", {
        blId,
        msg: data,
        username,
        uid,
        color,
    });
};

export const updateVersion = (vmInstance) => {
    sendMessageToServer("updateVersion", { json: vmInstance.toJSON() });
};
